'use client';

import clsx from 'clsx';
import { forwardRef } from 'react';
import { ChipProps } from './Chip.props';

import './Chip.scss';

export const Chip = forwardRef<HTMLInputElement, ChipProps>(
  ({ chipSize, className, variant, ...props }, ref) => {
    return (
      <div
        className={clsx(
          'chip',
          chipSize && `chip-size-${chipSize}`,
          variant && `chip-variant-${variant}`,
          className,
        )}
        ref={ref}
      >
        {props.children}
      </div>
    );
  },
);
export default Chip;
